<script>
	import { Icon } from '@ctm/icons';
	import { ChevronLeft, ChevronRight } from '@ctm/icons/directional';
	import ExternalLink from '$lib/components/icons/ExternalLink.svelte';
	import { tooltip } from '$lib/helpers/tooltip.js';
	import styles from './Sidebar.module.css';
	import { appUserLink } from '$lib/helpers/appUserLink';

	export let expandable = false;
	export let links = [];
	export let currentRoute = '';
	export let logo = '';

	$: open = expandable ?? false;
</script>

<div class="sidebar {open ? 'expanded' : 'collapsed'}">
	<div class="header">
		{#if open}
			{#if logo && logo.length > 0}
				<img class="sidebar-logo" alt="debtorLogo" src={logo} />
			{:else}
				<div class="welcomeProfile_noLogo" />
			{/if}
		{/if}
		<div class="expand-icon">
			<button class:hidden={!expandable} class="toggle-btn" class:right-chevron={!open} on:click={() => (open = !open)}>
				{#if open}
					<Icon icon={ChevronLeft} size="md" />
				{:else}
					<Icon icon={ChevronRight} size="md" />
				{/if}
			</button>
		</div>
	</div>

	<nav aria-label="Main navigation" class="sidebar">
		<ul>
			{#each links as link}
				<li>
					{#if link.external}
						<a
							href={appUserLink(link.href)}
							target="_blank"
							rel="noopener"
							class:selected={currentRoute.startsWith(link.href)}
							use:tooltip={!open ? { theme: 'light', placement: 'right', data: link.label } : null}
						>
							<span class="icon">
								{#if link.icon}
									<Icon class="{styles['sidebar-link-icon']} {currentRoute.startsWith(link.href) ? styles['sidebar-link-icon-selected'] : ''}" icon={link.icon} size="md" />
								{/if}
							</span>
							{#if open}
								<span class="label external">{link.label}</span>
								<span class="external-link">
									<ExternalLink bgColor="transparent" textColor="#6D7880" />
								</span>
							{/if}
						</a>
					{:else}
						<a href={appUserLink(link.href)} class:selected={currentRoute.startsWith(link.href)} use:tooltip={!open ? { theme: 'light', placement: 'right', data: link.label } : null}>
							<span class="icon">
								{#if link.icon}
									<Icon class="{styles['sidebar-link-icon']} {currentRoute.startsWith(link.href) ? styles['sidebar-link-icon-selected'] : ''}" icon={link.icon} size="md" />
								{/if}
							</span>
							{#if open}
								<span class="label {currentRoute.startsWith(link.href) ? 'selected' : ''}" class:news={link.count > 0}>{link.label}</span>
								{#if link.count > 0}
									<span class="count">{link.count}</span>
								{/if}
							{:else if link.count > 0}
								<span class="dot"></span>
							{/if}
						</a>
					{/if}
				</li>
			{/each}
		</ul>
	</nav>
</div>

<style>
	.sidebar {
		background-color: #fff;
		color: white;
		height: 100vh;
		transition: width 0.3s ease;
		overflow: visible; /* allow toggle button to overflow */
		flex-shrink: 0;
		position: relative;
		z-index: 10;
		box-shadow: 2px 0 4px -2px rgba(32, 43, 51, 0.12);
	}

	.sidebar.collapsed {
		width: 60px;
	}

	.sidebar.expanded {
		width: 280px;
	}

	.icon {
		width: 24px;
		height: 24px;
		margin-right: 12px;
		flex-shrink: 0;
	}

	.label {
		color: #2d3840;
		font-size: 16px;
		font-weight: 600;
		line-height: 24px;
		white-space: nowrap;
	}

	.label.selected {
		color: #156af4;
	}
	.label.external,
	.label.news {
		flex: 1;
	}
	.external-link,
	.count {
		align-self: flex-end;
	}
	.count {
		background: #da1e28;
		border-radius: 11px;
		padding: 1px 10px;
		color: #fff;
		font-size: 14px;
		font-weight: 400;
		line-height: 21px;
	}
	.dot {
		height: 12px;
		width: 12px;
		background: #da1e28;
		border-radius: 50%;
		position: absolute;
		right: 16px;
		top: 8px;
	}
	.header {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 120px;
		padding: 0 1rem;
		box-sizing: border-box;
		position: relative;
	}

	.sidebar-logo {
		max-height: 60px;
		min-height: 45px;
		max-width: 100%;
		object-fit: contain;
	}
	.toggle-btn {
		border: none;
		background: white;
		cursor: pointer;
		height: 46px;
		width: 46px;
		border-radius: 50%;
		box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
		position: absolute;
		right: -20px;
		top: 50%;
		transform: translateY(-50%);
		padding: 10px;
	}

	.toggle-btn.right-chevron :global(svg) {
		width: 30px;
	}

	.toggle-btn.hidden {
		display: none;
	}

	ul {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	a {
		display: flex;
		align-items: center;
		text-decoration: none;
		color: #156af4;
		padding: 14px;
		transition: background 0.2s;
		position: relative;
	}

	a:hover {
		background-color: #e5effc;
	}

	a.selected {
		font-weight: bold;
		background-color: #d0e2ff;
	}

	.icon {
		display: inline-block;
		width: 24px;
		text-align: center;
		margin-right: 12px;
	}

	.sidebar.collapsed .label {
		display: none;
	}
	.welcomeProfile_noLogo {
		height: 60px;
		width: 100%;
		margin: 0 0 35px;
	}
</style>
